import { ChangeEvent, MutableRefObject, useCallback, useRef } from "react";
import WButton from "../wbutton/WButton";
import {
  useUpdateUsersPermissionsUserMutation,
  useUploadFileMutation,
} from "@/generated";
import { useRouter } from "next/router";
import WDataWrapper from "../wdata-wrapper/WDataWrapper";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

interface IProfileEditPictureFormProps {
  onDone?: () => void;
}

export const WProfileEditPictureForm = ({
  onDone,
}: IProfileEditPictureFormProps) => {
  const imageRef = useRef() as MutableRefObject<HTMLInputElement>;
  const router = useRouter();

  const { t } = useTranslation("profileEdit");

  const [uploadPicture, uploadPictureResponse] = useUploadFileMutation();
  const [updateAvatar, updateAvatarResponse] =
    useUpdateUsersPermissionsUserMutation();

  const userId = router.query["id"]?.toString();

  const onChange = useCallback(
    async (event: ChangeEvent<HTMLInputElement>) => {
      if (event?.target?.files?.length) {
        const avatarFile = event?.target?.files?.[0];

        if (avatarFile && userId) {
          await uploadPicture({ variables: { file: avatarFile } }).then(
            (result) =>
              updateAvatar({
                onCompleted: () => toast.success(t("saved-profile")),
                onError: () => toast.error(t("saved-profile-error")),
                variables: {
                  updateUsersPermissionsUserId: userId,
                  data: {
                    picture: result?.data?.upload?.data?.id,
                  },
                },
              }).then(() => {
                if (onDone) {
                  onDone();
                }
              })
          );
        }
      }
    },
    [onDone, t, updateAvatar, uploadPicture, userId]
  );

  const onChoosePicture = () => {
    imageRef?.current?.click();
  };

  return (
    <WDataWrapper
      isLoading={
        uploadPictureResponse?.loading || updateAvatarResponse?.loading
      }
      isError={uploadPictureResponse?.error || updateAvatarResponse?.error}
      isData
    >
      <div className="w-full">
        <div className="flex flex-col w-full gap-5">
          <input
            ref={imageRef}
            className="hidden peer"
            type="file"
            onChange={onChange}
            id="update-avatar"
          />
          <WButton
            text={t("choose-picture")?.toUpperCase()}
            type="primary"
            className=""
            onClick={onChoosePicture}
          />
        </div>
      </div>
    </WDataWrapper>
  );
};

export default WProfileEditPictureForm;
